import type { RebalanceChangeSummary } from './buildRebalanceChangeSummary';

/** Derived advisor-facing situation keys for portfolio decision copy. */
export const AdvisorSituationKey = {
  CashRaise: 'CASH_RAISE',
  CashDeploy: 'CASH_DEPLOY',
  CashMode: 'CASH_MODE',
  MultiCurrency: 'MULTI_CURRENCY',
} as const;

/** Optimizer decision stages echoed in audit/run payloads. */
export const OptimizerDecisionStage = {
  TaxLocation: 'TAX_LOCATION',
  RebalanceMode: 'REBALANCE_MODE',
  FundingSegregation: 'FUNDING_SEGREGATION',
  Turnover: 'TURNOVER',
  InvariantCheck: 'INVARIANT_CHECK',
  ConstraintCompile: 'CONSTRAINT_COMPILE',
  Rounding: 'ROUNDING',
  TradeGeneration: 'TRADE_GENERATION',
  ReturnsFetch: 'RETURNS_FETCH',
  TransactionCost: 'TRANSACTION_COST',
  FxCost: 'FX_COST',
  TaxLotSelection: 'TAX_LOT_SELECTION',
  HarvestScan: 'HARVEST_SCAN',
  WashSaleCheck: 'WASH_SALE_CHECK',
  Validation: 'VALIDATION',
} as const;

/** Optimizer decision impact echoed in audit/run payloads. */
export const OptimizerDecisionImpact = {
  None: 'NONE',
  Minor: 'MINOR',
  Material: 'MATERIAL',
  Blocking: 'BLOCKING',
} as const;

export const PORTFOLIO_SITUATION_DECISION_STAGES_HIDDEN = new Set<string>([
  OptimizerDecisionStage.TaxLocation,
]);

export const PORTFOLIO_CASH_SITUATION_KEYS = new Set<string>([
  AdvisorSituationKey.CashRaise,
  AdvisorSituationKey.CashDeploy,
]);

export const CASH_EVENT_NOTE_STAGES = new Set<string>([
  AdvisorSituationKey.CashRaise,
  AdvisorSituationKey.CashDeploy,
  AdvisorSituationKey.MultiCurrency,
]);

export const isCashEventNoteStage = (stage: string): boolean =>
  CASH_EVENT_NOTE_STAGES.has(stage);

export const isCashSituationDuplicatedInChanges = (
  key: string,
  changes: RebalanceChangeSummary,
): boolean => {
  if (key === AdvisorSituationKey.CashRaise) {
    return changes.displayCashRaiseCents > 0;
  }

  if (key === AdvisorSituationKey.CashDeploy) {
    return changes.displayCashDeployCents > 0;
  }

  return false;
};
